import { render, staticRenderFns } from "./MealsFilterDropdown.vue?vue&type=template&id=50fd8d50&scoped=true&"
import script from "./MealsFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./MealsFilterDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MealsFilterDropdown.vue?vue&type=style&index=0&id=50fd8d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd8d50",
  null
  
)

export default component.exports